import { Platform } from 'react-native'
import { speller, Storage } from 'src/utils'

import {
  AuthData,
  AuthPayload,
  LogoutPayload,
  PreAuthData,
  PreAuthPayload,
  PreAuthResponse,
  PreAuthSendCode
} from './types'
import client from '../../client'
import { ResponseSuccess } from '../../types'

export const FORMATION_TOKEN_KEY = 'form_token_pre_auth'

/**
 * This method aims to facilitate obtaining an authentication code during development
 */
export const fetchAndPrintAuthCode_DEV_MODE = async (id: string) => {
  if (!__DEV__) {
    throw new Error(
      'The fetchAndPrintAuthCode_DEV_MODE method should not be run outside of the DEV environment.'
    )
  }

  const response = await client.get<ResponseSuccess<{ code: string }>>(
    `v1/__develop_/_force-logout_/${id}`
  )

  console.info(`Your Auth Code is: ${JSON.stringify(response.data.data?.code)}`)
}

export const preAuth = async (data: PreAuthPayload) => {
  if (Platform.OS === 'web') {
    const formToken = speller(JSON.stringify(data))

    await Storage.setItem(FORMATION_TOKEN_KEY, formToken)
  }

  const response = await client.post<ResponseSuccess<PreAuthResponse>>('v1/pre-auth', data)

  return response
}

export const auth = ({ slt, ...data }: AuthPayload) => {
  return client.post<ResponseSuccess<AuthData>>('v1/auth', data, {
    headers: {
      'x-slt': slt
    }
  })
}

export const logout = ({ ...data }: LogoutPayload) =>
  client.delete<ResponseSuccess<any>>('v1/auth', { data })

export const acceptTerms = async () => {
  const commitmentResponse = client.patch<ResponseSuccess<null>>('v1/users/me/term/1/accept')

  const responsibilityResponse = client.patch<ResponseSuccess<null>>('v1/users/me/term/2/accept')

  const response = await Promise.all([commitmentResponse, responsibilityResponse])

  return response
}

export const authSendCode = async ({ type, slt, user_id }: PreAuthSendCode) => {
  const response = await client.post<ResponseSuccess<PreAuthData>>(
    `v1/auth/${type}-authentication`,
    { user_id },
    {
      headers: {
        'x-slt': slt
      }
    }
  )

  if (__DEV__) {
    await fetchAndPrintAuthCode_DEV_MODE(user_id)
  }

  return response
}
